module.exports = __webpack_public_path__ + "img/MGH-Roppongi-11.ed9a8bb9.jpg";